import { create } from 'zustand'

export interface WmsSourceConfig {
  id: string
  name: string
  endpoint: string
  layers: string[]
}

interface MapState {
  center: [number, number]  // [lon, lat] - GeoJSON order
  zoom: number
  wmsEndpoint: string
  wmsLayers: string[]
  wmsSources: WmsSourceConfig[]
  activeWmsSourceId: string | null
  preferredCoordFormat: 'dd' | 'dms' | 'mgrs' | 'utm'

  setCenter: (center: [number, number]) => void
  setZoom: (zoom: number) => void
  setWmsEndpoint: (endpoint: string) => void
  setWmsLayers: (layers: string[]) => void
  setWmsSources: (sources: WmsSourceConfig[]) => void
  setActiveWmsSourceId: (sourceId: string | null) => void
  setPreferredCoordFormat: (fmt: 'dd' | 'dms' | 'mgrs' | 'utm') => void
}

export const useMapStore = create<MapState>((set) => ({
  center: [0, 20],  // [lon, lat] - GeoJSON order
  zoom: 3,
  wmsEndpoint: '',
  wmsLayers: [],
  wmsSources: [],
  activeWmsSourceId: null,
  preferredCoordFormat: 'dd',

  setCenter: (center) => set({ center }),
  setZoom: (zoom) => set({ zoom }),
  setWmsEndpoint: (wmsEndpoint) => set({ wmsEndpoint }),
  setWmsLayers: (wmsLayers) => set({ wmsLayers }),
  setWmsSources: (wmsSources) => set({ wmsSources }),
  setActiveWmsSourceId: (activeWmsSourceId) => set({ activeWmsSourceId }),
  setPreferredCoordFormat: (preferredCoordFormat) => set({ preferredCoordFormat }),
}))
